import React, { Component } from "react";
import { Link } from "react-router-dom";
import Alert from "sweetalert-react";
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Bold } from "../Styles";
import {
  getAppliedJobs as getAppliedJobsAction,
  unapply as unapplyAction,
} from "../../redux/middleware/job";
import { Loader } from "../Shared";
import { Header, HeaderTitle, Icon } from "./Styles/Jobs.style";

const IconLink = Icon.withComponent(Link);

const JobRow = ({ job, confirm }) => (
  <tr>
    <td style={{ paddingTop: 15 }}>
      <Bold>{job.title}</Bold>
    </td>
    <td className="hidden-xs" style={{ paddingTop: 15 }}>
      <i className="fa fa-calendar" />
      &nbsp;
      {moment(job.applyDate).format("MM-DD-YYYY")}
    </td>
    <td className="hidden-xs" style={{ paddingTop: 15 }}>
      {job.status}
    </td>
    <td>
      <div>
        <Icon className="btn_status" alt="trash" onClick={() => confirm(job)}>
          <i className="fa fa-trash" />
        </Icon>
        <IconLink
          className="btn btn_status"
          alt="view"
          to={`/jobs/${job.slug}`}
        >
          <i className="fa fa-search" />
        </IconLink>
      </div>
    </td>
  </tr>
);

const JobsTable = ({ jobs, confirm, remove }) => {
  if (jobs && jobs.length === 0) {
    return (
      <div style={{ padding: "100px 20px" }}>
        You have not applied to any jobs yet. Click <a href="/jobs">here</a>
        &nbsp;to find your next job!
      </div>
    );
  }
  return (
    <table cellSpacing="0" cellPadding="0" className="table">
      <thead>
        <tr>
          <th className="bdl_radius hidden-xs" width="30%">
            Title
          </th>
          <th className="bdl_radius visible-xs" width="70%">
            Title
          </th>
          <th className="hidden-xs" width="26%">
            Date Applied
          </th>
          <th className="hidden-xs" width="1%">
            Status
          </th>
          <th width="30%" />
        </tr>
      </thead>
      <tbody>
        {jobs.map((job) => (
          <JobRow key={job.id} job={job} confirm={confirm} remove={remove} />
        ))}
      </tbody>
    </table>
  );
};

class Jobs extends Component {
  constructor(props) {
    super(props);
    this.state = { show: false };
  }

  componentWillMount() {
    const { user, getApplicantJobs } = this.props;
    getApplicantJobs(user);
  }

  componentWillReceiveProps(nextProps) {
    const { unapplyJobPending, notify, user, getApplicantJobs } = this.props;
    if (unapplyJobPending && !nextProps.unapplyJobPending) {
      if (!nextProps.error) {
        notify("success", nextProps.unapplyJob.message);
        getApplicantJobs(user);
      } else {
        notify("error", "There was an error in removing the job, try again");
      }
    }
  }

  confirm = (job) => {
    this.setState({ show: true, job });
  };

  remove = (job) => {
    const { user, unapply } = this.props;
    unapply(user, job);
    this.setState({ show: false });
  };

  cancel = () => this.setState({ show: false });

  render() {
    const { pending, jobs: propJobs } = this.props;
    const { show, job } = this.state;
    if (pending || !propJobs)
      return <Loader vwidth="60vw" fullScreen show />;

    const jobs = propJobs.sort((a, b) => {
      const d1 = new Date(a.apply_date);
      const d2 = new Date(b.apply_date);
      return d2 - d1;
    });

    return (
      <div className="TabbedPanelsContent">
        <Header>
          <HeaderTitle>Jobs</HeaderTitle>
        </Header>
        <JobsTable jobs={jobs} confirm={this.confirm} remove={this.remove} />
        <Alert
          title="Are you sure?"
          text="Once deleted, you will not be able to recover this job!"
          type="warning"
          show={show}
          onConfirm={() => this.remove(job)}
          onCancel={this.cancel}
          showCancelButton
          buttons
          dangerMode
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    jobs: state.appliedJobs.jobs,
    pending: state.appliedJobs.pending,
    unapplyJob: state.unapplyJob.job,
    unapplyJobPending: state.unapplyJob.pending,
    unapplyError: state.unapplyJob.error,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getApplicantJobs: getAppliedJobsAction,
      unapply: unapplyAction,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Jobs);
